import axios from '@axios';
import HelperService from '@/services/HelperService';

const helperService = new HelperService();

const base = '/api/v1/visitor-users';
const baseContacts = '/api/v1/contacts';
const baseBans = '/api/v1/bans';

export default {
  getVisitorsWithContactInPrison(){
    return axios.get(`${base}/have-contact-in-prison`);
  },
  getVisitorsWithContactInPrisonPaginated(filters){
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/have-contact-in-prison/paginated${queryString}`);
  },
  getVisitor(visitorId){
    return axios.get(`${base}/user/` + visitorId);
  },
  getVisitorContacts(visitorId){
    return axios.get(`${baseContacts}/user/` + visitorId);
  },
  getPreviousVisits(visitorId){
    return axios.get(`/api/v1/visits/visitor-user/` + visitorId + `/previous-visits`);
  },
  getVisitorBans(visitorId){
    return axios.get(`${baseBans}/user/` + visitorId);
  },
  removeVisitorBan(banId){
    return axios.delete(`${baseBans}/delete/` + banId);
  },
  createBan(banData){
    return axios.post(`${baseBans}/create`, banData);
  },
  getOffsiteVisitorsAtEstablishment(offsiteId) {
    return axios.get(`/api/v1/visitor-users/get-offsite-visitors-at-establishment/${offsiteId}`);
  },
  registerOffsiteVisitor(dto) {
    return axios.post('/api/v1/visitor-users/register-offsite-visitor', dto);
  },
  updateOffsiteVisitorsEstablishment(contactId, dto) {
    return axios.post(`/api/v1/visitor-users/update-offsite-visitors-establishment/${contactId}`, dto);
  },
  getVisitorUserAgeDistStats(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/stats/visitor-count${queryString}`);
  },
  // getAdditionalVisitorUserAgeDistStats(filters) {
  //   const queryString = helperService.buildSearchQueryString(filters);
  //   return axios.get(`${base}/stats/additional-visitor-count${queryString}`);
  // },
  registerOnDemandVisitor(dto) {
    return axios.post(`${base}/register/on-demand`, dto);
  },
};
